import React from "react";
import { ChartTheme } from "../theme/chartColors";
import {
  SimpleSelect,
  SimpleSelectTrigger,
  SimpleSelectContent,
  SimpleSelectItem,
} from "hardcover-ui/components/SimpleSelect";
import ColorCircleIcon from "./ColorCircleIcon";

const themes = [
  { id: "colorful", name: "Colorful" },
  { id: "monochrome", name: "Monochrome" },
] as const;

interface ChartThemePickerProps {
  value: ChartTheme;
  onChange: (theme: ChartTheme) => void;
}

export default function ChartThemePicker({
  value,
  onChange,
}: ChartThemePickerProps) {
  return (
    <SimpleSelect value={value} onValueChange={onChange}>
      <SimpleSelectTrigger className=" border-none rounded-full!">
        <div className="flex items-center justify-center w-4">
          <ColorCircleIcon theme={value} />
        </div>
      </SimpleSelectTrigger>
      <SimpleSelectContent>
        <div className="flex flex-col p-1">
          {themes.map((theme) => (
            <SimpleSelectItem key={theme.id} value={theme.id} className="py-1!">
              <div className="flex items-center gap-2">
                <ColorCircleIcon theme={theme.id} size={16} />
                <span>{theme.name}</span>
              </div>
            </SimpleSelectItem>
          ))}
        </div>
      </SimpleSelectContent>
    </SimpleSelect>
  );
}
